<template>
    <div :class="['sidenav ', { active: show }]">
        <div class="menu">
            <div>
                <ul>
                    <li v-show="user.planType && user.planType.length">
                        <a
                            @click="pushRoute({ url: 'DashboardSupplier', solo: false })"
                            :class="[{ active: $route.name === 'DashboardSupplier' }]"
                        >
                            <span class="icon-render"><i class="icon-menu-supplier fas fa-home"></i></span>
                            <span class="icon-title">Home</span>
                        </a>
                    </li>
                    <!-- <li>
                        <a href="https://app.leadlovers.com/login" target="_blank"
                            ><span class="icon-render"><i class="icon-menu-supplier fas fa-filter"></i></span>
                            <span class="icon-title">Funil de Vendas</span></a
                        >
                    </li> -->
                    <li>
                        <a
                            @click="pushRoute({ url: 'CompetitionDashboard', solo: false })"
                            :class="[{ active: $route.name === 'CompetitionDashboard' }]"
                            ><span class="icon-render"
                                ><img src="@/assets/images/dashboard.svg" class="icon-menu-supplier" height="16px" />
                            </span>
                            <span class="icon-title"
                                >Painel <span v-if="!user.type.hasSubscription">de Cotações</span>
                            </span></a
                        >
                    </li>
                    <li v-if="supplierData.contactNetwork">
                        <a
                            @click="pushRoute({ url: 'ContactNetwork', solo: false })"
                            :class="[{ active: $route.name === 'ContactNetwork' }]"
                            ><span class="icon-render"
                                ><img src="@/assets/images/multiple.svg" class="icon-menu-supplier" height="16px"
                            /></span>
                            <span class="icon-title">Leads Prediais</span></a
                        >
                    </li>
                    <li>
                        <a
                            @click="pushRoute({ url: 'MyOpportunities', solo: false })"
                            :class="[{ active: $route.name === 'MyOpportunities' }]"
                        >
                            <span class="icon-render"><i class="icon-menu-supplier fas fa-th-list"></i></span
                            ><span class="icon-title">Oportunidades</span>
                        </a>
                    </li>
                    <li>
                        <a
                            @click="pushRoute({ url: 'MyContacts', solo: false })"
                            :class="[{ active: $route.name === 'MyContacts' }]"
                        >
                            <span class="icon-render"
                                ><i class="icon-menu-supplier fas fa-chevron-circle-down"> </i
                            ></span>
                            <span class="icon-title">Aquisições</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <ul class="footer-info">
                    <li class="h-34">
                        <a @click="pushRoute({ url: 'ContactUs', solo: false })">
                            <span class="icon-render"><i class="icon-menu-supplier-footer fas fa-comments"></i></span>
                            <span v-show="show" class="icon-title">Fale Conosco</span>
                        </a>
                    </li>
                    <li class="h-34">
                        <a @click="pushRoute({ url: 'CondoTechsLandingpage', solo: false })"
                            ><span class="icon-render"
                                ><img
                                    style="margin-right: 25px"
                                    class="icon-menu-supplier-footer icons-condor"
                                    src="@/assets/images/condotech.svg"
                                    height="10"
                                />
                            </span>
                            <span v-show="show" class="icon-title">Condotechs</span></a
                        >
                    </li>
                    <li class="h-34">
                        <a href="https://static.app.engelink.com.br/termos-de-uso.pdf" target="_blank"
                            ><span class="icon-render"
                                ><img
                                    style="margin-right: 25px"
                                    class="icon-menu-supplier-footer icons-terms"
                                    src="@/assets/images/terms.svg"
                                    height="10"
                            /></span>
                            <span v-show="show" class="icon-title">Termos de uso</span></a
                        >
                    </li>
                    <li class="h-71">
                        <a href="javascript:void(0);">
                            <span class="icon-render"
                                ><i class="icon-menu-supplier-footer fas fa-info-circle"></i
                            ></span>
                            <span v-show="show" class="icon-title"
                                >Funcionamento <br />Segunda a sexta<br />
                                das 9h às 18h</span
                            ></a
                        >
                    </li>
                    <li class="h-101">
                        <a href="javascript:void(0);">
                            <span class="title-footer copyright" v-if="show">
                                © 2017-{{ new Date().getFullYear() }} Engelink Tecnologia Ltda.<br />
                                Todos os direitos reservados
                            </span>
                            <span class="copyright-footer" v-else> © </span>
                        </a>
                    </li>
                </ul>
            </div>
            <button @click="btnShow" :class="['btn-arrow', { active: show }]">
                <font-awesome-icon :icon="['fas', arrow]" class="icon-arrow" />
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'SupplierSideBar',
    data: () => ({
        show: false
    }),
    methods: {
        ...mapActions('layout', ['setSideMenu']),
        btnShow() {
            this.show = !this.show;
            this.setSideMenu(this.show);
            this.$emit('show', this.show);
        },
        pushRoute(objectUrl) {
            if (objectUrl.solo) {
                window.open(objectUrl.url, '_blank');
            } else if (objectUrl.url && this.$route.name != objectUrl.url) {
                const router = { name: objectUrl.url };
                if (objectUrl.query) router.query = objectUrl.query;
                this.$router.push(router);
            }
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('user', ['supplierData']),
        arrow() {
            return this.show ? 'chevron-left' : 'chevron-right';
        },
        showNewEngelinkMarketing() {
            return this.user.type.hasSubscription && this.supplierData.engelinkMarketingVisualized;
        },
        newTagPosition() {
            return {
                'margin-left': '-25px',
                'z-index': '1',
                'margin-top': '-5px',
                'margin-right': '16px'
            };
        }
    }
};
</script>
<style lang="scss">
/* Main  */
.menu {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    z-index: 99999 !important;
}
/* Header */
.sidenav {
    text-align: justify;
    position: fixed;
    height: 100%;
    width: 50px;
    z-index: 1;
    background-color: #0f2d53;
    margin-top: 38px;
    transition: 0.5s;
    overflow: hidden;
}
.sidenav.active {
    width: 215px;
}
.icon-render {
    position: relative;
    display: block;
}
.sidenav ul {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
}
.sidenav ul li {
    position: relative;
    width: 100%;
    list-style: none;
    cursor: pointer;
}
.sidenav ul li a {
    position: relative;
    display: block;
    width: 100%;
    display: flex;
    text-decoration: none;
    padding: 13px 16px 13px 16px;
    text-decoration: none;
    font-size: 13px;
    color: #fff;
}
.sidenav ul li a .icon-render {
    position: relative;
    display: block;
}
.sidenav ul li a .icon-title {
    position: relative;
    display: block;
    padding: 0 10px;
    text-align: start;
    white-space: nowrap;
}
.sidenav ul li a:hover {
    color: #f1f1f1;
    background-color: #343f4d;
}
.sidenav ul li a.active {
    color: #f1f1f1;
    background-color: #009fe3;
}
.icon-menu-supplier {
    margin-right: 20px;
    font-size: 16px;
}
.icon-menu-supplier.fa-home {
    margin-right: 18px;
}

.btn-arrow {
    border: 0px solid black;
    box-shadow: 0px 3px 6px #00000029;
    margin-top: 25px;
    margin-left: 40px;
    background-color: white;
    color: white;
    position: fixed;
    width: 25px;
    height: 25px;
    color: #fff;
    border-radius: 30px;
    text-align: center;
    transition: 0.5s;
    overflow: hidden;
    padding-left: 9px;
    padding-top: 6px;
}
.btn-arrow.active {
    margin-left: 200px;
    padding-left: 5px;
}
button:focus {
    background-color: #fff;
}
.icon-arrow {
    font-size: 13px;
    color: #a5a5a5;
    margin-bottom: 6px;
}
/* Footer menu */
.sidenav li a .title-footer {
    padding-top: 10px;
    padding-bottom: 20px;
    border-top: 1px solid #7fa1cb;
    text-align: justify;
    white-space: nowrap;
    transition: 0.1s;
}

.sidenav li a .title-footer.copyright {
    white-space: wrap;
    text-align: left;
    white-space: normal;
}

.sidenav li a .copyright-footer {
    padding-top: 10px;
    padding-bottom: 30px;
    font-size: 12px;
    text-align: justify;
    white-space: nowrap;
}
.footer-info {
    bottom: 0;
    position: fixed;
    padding-bottom: 18px;
}
.sidenav .footer-info {
    position: relative;
    width: 100%;
    list-style: none;
}
.sidenav .footer-info a:hover {
    background-color: #0f2d53;
    color: #7fa1cb;
}
.sidenav .footer-info a {
    position: relative;
    display: block;
    width: 100%;
    display: flex;
    text-decoration: none;
    padding: 8px 16px 8px 16px;
    text-decoration: none;
    font-size: 12px;
    color: #7fa1cb;
}
.sidenav .footer-info a .icon-menu-supplier-footer {
    position: relative;
    display: block;
    margin-right: 25px;
}

.sidenav .footer-info a .icon-menu-supplier-footer.fa-comments {
    margin-right: 20px;
}

.sidenav .footer-info a .icon-menu-supplier-footer.fa-info-circle {
    margin-right: 21px;
}

.sidenav .footer-info a .icons-terms {
    margin-right: 21px;
}

.sidenav .footer-info a .icons-condor {
    margin-right: 21px;
}

.sidenav .footer-info a .icon-title {
    position: relative;
    display: block;
    padding: 0 10px;
    text-align: start;
    white-space: nowrap;
}

.h-34 {
    height: 34px;
}

.h-71 {
    height: 71px;
}

.h-101 {
    height: 101px;
}
</style>
